import React from "react";
import seloSystems from "../public/selo-systems.png";

/** Assinatura da empresa que desenvolve o sistema */
const SeloSystems = ({ texto = "Desenvolvido por" }) => (
    <div className="selo-systems">
        <img src={seloSystems} alt="Selo Systems" />
        <span>{texto} Selo Systems</span>
    </div>
);

export default SeloSystems;
